module.exports = __webpack_public_path__ + "static/media/vegetarian.9c666f0d.jpg";